import { utcToZonedTime } from 'date-fns-tz';
import appConstants from '../../../../appConstants';
import { format } from 'date-fns';

export const getCurrentTerminalDateAndTime = (terminalOffset) => {
  return format(
    utcToZonedTime(new Date(), terminalOffset),
    appConstants.DATETYPES.DATETIME.format
  );
};
